/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { IS_BROWSER } from '@zcode/env'

export const isBrowserWindow = () => {
  return IS_BROWSER && typeof window !== 'undefined'
}
